(function () {
  function iniciarProducto(seccion) {
    if (seccion.dataset.iniciado === 'true') return;
    seccion.dataset.iniciado = 'true';

    var carrusel = seccion.querySelector('[data-carrusel]');
    var miniaturas = seccion.querySelectorAll('[data-miniatura]');
    var imagenes = seccion.querySelectorAll('[data-imagen-item]');
    var puntos = seccion.querySelectorAll('[data-punto]');
    var variantesNodo = seccion.querySelector('[data-variantes-producto]');
    var variantes = [];

    if (variantesNodo) {
      try {
        variantes = JSON.parse(variantesNodo.textContent);
      } catch (error) {
        variantes = [];
      }
    }

    var textosColorNodo = seccion.querySelector('[data-textos-color]');
    var textosColor = [];

    if (textosColorNodo) {
      try {
        textosColor = JSON.parse(textosColorNodo.textContent);
      } catch (error) {
        textosColor = [];
      }
    }

    var notaColorElemento = seccion.querySelector('[data-nota-color]');
    var valorActivoElemento = seccion.querySelector('[data-valor-activo]');

    function obtenerValoresActivos() {
      var valores = [];
      var grupos = seccion.querySelectorAll('[data-grupo-opcion]');
      for (var i = 0; i < grupos.length; i++) {
        var activo = grupos[i].querySelector('.producto__valor--activo');
        if (activo) valores.push(activo.getAttribute('data-valor'));
      }
      return valores;
    }

    function actualizarValorActivo() {
      if (!valorActivoElemento) return;
      var grupos = seccion.querySelectorAll('[data-grupo-opcion]');
      var partes = [];
      for (var i = 0; i < grupos.length; i++) {
        var nombre = grupos[i].getAttribute('data-nombre-opcion');
        var activo = grupos[i].querySelector('.producto__valor--activo');
        var valor = activo ? activo.getAttribute('data-valor') : null;
        if (nombre && valor) partes.push(nombre + ': ' + valor);
      }
      valorActivoElemento.textContent = partes.join(' · ');
    }

    function escaparHtml(texto) {
      var div = document.createElement('div');
      div.textContent = texto || '';
      return div.innerHTML;
    }

    function aplicarTextoColor() {
      if (!notaColorElemento) return;
      var valoresActivos = obtenerValoresActivos();
      var coincidencia = textosColor.filter(function (item) {
        return valoresActivos.indexOf(item.color) !== -1;
      })[0];
      if (coincidencia && (coincidencia.titulo || coincidencia.descripcion)) {
        var etiqueta = coincidencia.titulo ? '<strong>' + escaparHtml(coincidencia.titulo) + '</strong>' : '';
        notaColorElemento.innerHTML = etiqueta + (coincidencia.descripcion || '');
        notaColorElemento.hidden = false;
      } else {
        notaColorElemento.innerHTML = '';
        notaColorElemento.hidden = true;
      }
    }

    aplicarTextoColor();
    actualizarValorActivo();

    function iniciarCountdownOferta() {
      var contenedor = seccion.querySelector('[data-countdown-oferta]');
      if (!contenedor) return;

      var fechaFin = new Date(contenedor.getAttribute('data-fecha-fin'));
      if (isNaN(fechaFin.getTime())) return;

      var elementoTiempo = contenedor.querySelector('[data-countdown-tiempo]');
      var intervalo;

      function actualizar() {
        var diferencia = fechaFin.getTime() - Date.now();
        if (diferencia <= 0) {
          contenedor.hidden = true;
          if (intervalo) clearInterval(intervalo);
          return;
        }
        contenedor.hidden = false;
        var dias = Math.floor(diferencia / 86400000);
        var horas = Math.floor((diferencia / 3600000) % 24);
        var minutos = Math.floor((diferencia / 60000) % 60);
        var segundos = Math.floor((diferencia / 1000) % 60);
        var partes = [];
        if (dias > 0) partes.push(dias + 'd');
        partes.push((horas < 10 ? '0' : '') + horas + 'h');
        partes.push((minutos < 10 ? '0' : '') + minutos + 'm');
        partes.push((segundos < 10 ? '0' : '') + segundos + 's');
        if (elementoTiempo) elementoTiempo.textContent = partes.join(' ');
      }

      actualizar();
      intervalo = setInterval(actualizar, 1000);
    }

    iniciarCountdownOferta();

    function formatearDinero(centavos) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
          style: 'currency',
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR'
        }).format(centavos / 100);
      } catch (error) {
        return centavos / 100;
      }
    }

    function marcarImagenActiva(indice) {
      imagenes.forEach(function (imagen) {
        imagen.classList.toggle('producto__imagen-item--activa', imagen.getAttribute('data-indice') === String(indice));
      });
      miniaturas.forEach(function (miniatura) {
        miniatura.classList.toggle('producto__miniatura--activa', miniatura.getAttribute('data-indice') === String(indice));
      });
      puntos.forEach(function (punto) {
        punto.classList.toggle('producto__punto--activo', punto.getAttribute('data-indice') === String(indice));
      });
    }

    function irAImagen(indice) {
      marcarImagenActiva(indice);
      var objetivo = seccion.querySelector('[data-imagen-item][data-indice="' + indice + '"]');
      if (objetivo && carrusel) {
        carrusel.scrollTo({ left: objetivo.offsetLeft, behavior: 'smooth' });
      }
    }

    function irAImagenPorMedia(mediaId) {
      if (!mediaId) return;
      var objetivo = seccion.querySelector('[data-imagen-item][data-media-id="' + mediaId + '"]');
      if (objetivo) irAImagen(objetivo.getAttribute('data-indice'));
    }

    miniaturas.forEach(function (miniatura) {
      miniatura.addEventListener('click', function () {
        irAImagen(miniatura.getAttribute('data-indice'));
      });
    });

    puntos.forEach(function (punto) {
      punto.addEventListener('click', function () {
        irAImagen(punto.getAttribute('data-indice'));
      });
    });

    if (carrusel && 'IntersectionObserver' in window && imagenes.length > 1) {
      var observador = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting && entrada.intersectionRatio > 0.6) {
              marcarImagenActiva(entrada.target.getAttribute('data-indice'));
            }
          });
        },
        { root: carrusel, threshold: 0.6 }
      );
      imagenes.forEach(function (imagen) {
        observador.observe(imagen);
      });
    }

    function seleccionActual() {
      var seleccion = [];
      seccion.querySelectorAll('[data-grupo-opcion]').forEach(function (grupo) {
        var activo = grupo.querySelector('.producto__valor--activo');
        seleccion.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return seleccion;
    }

    function buscarVariante(seleccion) {
      return variantes.filter(function (variante) {
        var opciones = [variante.option1, variante.option2, variante.option3];
        return seleccion.every(function (valor, indice) {
          return opciones[indice] === valor;
        });
      })[0];
    }

    function actualizarEstadoBotones(seleccionActiva) {
      seccion.querySelectorAll('[data-grupo-opcion]').forEach(function (grupo, indiceGrupo) {
        grupo.querySelectorAll('[data-valor-opcion]').forEach(function (boton) {
          var hipotesis = seleccionActiva.slice();
          hipotesis[indiceGrupo] = boton.getAttribute('data-valor');
          var candidata = buscarVariante(hipotesis);

          boton.classList.remove('producto__valor--inexistente', 'producto__valor--agotada');
          if (!candidata) {
            boton.classList.add('producto__valor--inexistente');
          } else if (!candidata.available) {
            boton.classList.add('producto__valor--agotada');
          }
        });
      });
    }

    function aplicarVariante(variante) {
      var precio = seccion.querySelector('[data-precio]');
      var precioActual = seccion.querySelector('[data-precio-actual]');
      var precioAnterior = seccion.querySelector('[data-precio-anterior]');
      var disponibilidad = seccion.querySelector('[data-disponibilidad]');
      var pocasUnidades = seccion.querySelector('[data-pocas-unidades]');
      var idVariante = seccion.querySelector('[data-id-variante]');
      var boton = seccion.querySelector('[data-boton-comprar]');
      var textoBoton = seccion.querySelector('[data-texto-boton]');

      if (!variante) {
        if (boton) boton.disabled = true;
        if (disponibilidad) disponibilidad.hidden = false;
        return;
      }

      if (idVariante) idVariante.value = variante.id;

      if (precioActual) precioActual.textContent = formatearDinero(variante.price);
      if (precioAnterior) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAnterior.textContent = formatearDinero(variante.compare_at_price);
          precioAnterior.hidden = false;
        } else {
          precioAnterior.hidden = true;
        }
      }
      if (precio) precio.setAttribute('aria-label', formatearDinero(variante.price));

      if (disponibilidad) disponibilidad.hidden = !!variante.available;

      if (pocasUnidades) {
        var pocas =
          variante.available &&
          variante.inventory_management &&
          variante.inventory_policy !== 'continue' &&
          typeof variante.inventory_quantity === 'number' &&
          variante.inventory_quantity > 0 &&
          variante.inventory_quantity <= 5;
        pocasUnidades.hidden = !pocas;
      }

      if (boton) {
        boton.disabled = !variante.available;
      }
      if (textoBoton) {
        textoBoton.textContent = variante.available
          ? (seccion.dataset.textoComprar || 'Añadir al carrito')
          : (seccion.dataset.textoAgotado || 'Agotado');
      }

      if (variante.featured_media_id) {
        irAImagenPorMedia(variante.featured_media_id);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variante.id);
        window.history.replaceState({}, '', url);
      }
    }

    seccion.querySelectorAll('[data-valor-opcion]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        if (boton.classList.contains('producto__valor--inexistente')) return;
        var grupo = boton.closest('[data-grupo-opcion]');
        grupo.querySelectorAll('[data-valor-opcion]').forEach(function (hermano) {
          hermano.classList.remove('producto__valor--activo');
        });
        boton.classList.add('producto__valor--activo');

        var seleccion = seleccionActual();
        var variante = buscarVariante(seleccion);
        actualizarEstadoBotones(seleccion);
        aplicarVariante(variante);
        aplicarTextoColor();
    actualizarValorActivo();
      });

      var mediaIdPrevisualizar = boton.getAttribute('data-media-id');
      if (mediaIdPrevisualizar) {
        boton.addEventListener('mouseenter', function () {
          irAImagenPorMedia(mediaIdPrevisualizar);
        });
        boton.addEventListener('mouseleave', function () {
          var grupo = boton.closest('[data-grupo-opcion]');
          var activo = grupo ? grupo.querySelector('.producto__valor--activo[data-media-id]') : null;
          if (activo) {
            irAImagenPorMedia(activo.getAttribute('data-media-id'));
          }
        });
      }
    });

    var cantidadInput = seccion.querySelector('[data-cantidad]');
    var restar = seccion.querySelector('[data-restar]');
    var sumar = seccion.querySelector('[data-sumar]');

    if (restar && cantidadInput) {
      restar.addEventListener('click', function () {
        var valor = Math.max(1, (parseInt(cantidadInput.value, 10) || 1) - 1);
        cantidadInput.value = valor;
      });
    }
    if (sumar && cantidadInput) {
      sumar.addEventListener('click', function () {
        var valor = Math.max(1, (parseInt(cantidadInput.value, 10) || 1) + 1);
        cantidadInput.value = valor;
      });
    }

    var formulario = seccion.querySelector('[data-formulario-producto]');
    if (formulario) {
      formulario.addEventListener('submit', function (evento) {
        evento.preventDefault();
        var boton = seccion.querySelector('[data-boton-comprar]');
        var textoBoton = seccion.querySelector('[data-texto-boton]');
        if (!boton || boton.disabled) return;

        var idVariante = seccion.querySelector('[data-id-variante]').value;
        var cantidad = cantidadInput ? parseInt(cantidadInput.value, 10) || 1 : 1;
        var textoOriginal = textoBoton ? textoBoton.textContent : '';

        boton.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: idVariante, quantity: cantidad }] })
        })
          .then(function (respuesta) {
            if (!respuesta.ok) throw new Error('cart add failed');
            return respuesta.json();
          })
          .then(function () {
            if (textoBoton) textoBoton.textContent = 'Añadido';
            boton.classList.add('is-agregado');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.setTimeout(function () {
              if (textoBoton) textoBoton.textContent = textoOriginal;
              boton.classList.remove('is-agregado');
              boton.disabled = false;
            }, 1800);
          })
          .catch(function () {
            if (textoBoton) textoBoton.textContent = 'No se pudo añadir';
            window.setTimeout(function () {
              if (textoBoton) textoBoton.textContent = textoOriginal;
              boton.disabled = false;
            }, 2000);
          });
      });
    }
  }

  function iniciarTodo() {
    document.querySelectorAll('[data-producto]').forEach(iniciarProducto);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', iniciarTodo);
})();